import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import LoadingOverlay from "react-loading-overlay-ts";
import "../coreIdStyles.scss";
import {
  changeActiveComponent,
  changePageSize,
  changePageState,
  getDashboardItems,
  getFilteredRegistrations,
  resetRegistration,
  selectActiveCoreIdComponent,
  selectCoreIdLoading,
  selectCurrentFilterRequest,
  selectCurrentPageCoreId,
  selectFilteredRegistrations,
  selectMiniDashboardData,
  selectNumPagesCoreId,
  selectPageSizeCoreId,
} from "../coreIdSlice";
import ClipLoader from "react-spinners/ClipLoader";
import { changeCurrentProduct, selectRoles } from "../../../common/commonSlice";
import { formatDateStandar } from "../../../../helpers/utils";
import {
  createTag,
  disassociateTag,
  getAllTags,
  getCurrentTagsByService,
  selectAllTags,
  selectCurrentService,
  selectCurrentTagCreation,
  selectCurrentTagsByService,
  selectLoadingAllTags,
  selectLoadingCurrentTagsByService,
  setTagCreation,
} from "../../tags/tagSlice";
import { ReactComponent as DeleteTag } from "../../../../Assets/common/images/deleteTag.svg";
import { ReactComponent as AddTag } from "../../../../Assets/common/images/addTag.svg";
import { usePagination } from "pagination-react-js";
import PaginationItem from "../../../../helpers/PaginationItem";
import { Registration } from "../coreIdAPI";

export const Registrations = () => {
  let currentPage = useAppSelector(selectCurrentPageCoreId);
  let numPages = useAppSelector(selectNumPagesCoreId);
  const pageSize = useAppSelector(selectPageSizeCoreId);
  let loading = useAppSelector(selectCoreIdLoading);
  let activeComponent = useAppSelector(selectActiveCoreIdComponent);
  let miniDashboardData = useAppSelector(selectMiniDashboardData);
  let registrations = useAppSelector(selectFilteredRegistrations);
  let currentFilteredRequest = useAppSelector(selectCurrentFilterRequest);

  // Tag Stuff
  let currentService = useAppSelector(selectCurrentService);
  let loadingAllTags = useAppSelector(selectLoadingAllTags);
  let loadingTagsByService = useAppSelector(selectLoadingCurrentTagsByService);
  let allTags = useAppSelector(selectAllTags);
  let currentServiceTags = useAppSelector(selectCurrentTagsByService);
  let tagCreation = useAppSelector(selectCurrentTagCreation);
  const [addTagWindow, setAddTagWindow] = useState({ entityId: "" });
  let roles = useAppSelector(selectRoles);

  //Timer for search
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  let dispatch = useAppDispatch();
  let navigate = useNavigate();

  const getStatusName = (reg: Registration) => {
    let statusProgress = "En progreso: ";

    if (reg.abandoned) {
      statusProgress = "Abandonado: ";
    }

    switch (reg.status) {
      case "ACCEPTED":
        return "Aprobado";
      case "IN_PROGRESS":
        return "En progreso";
      case "REJECTED":
        return "Rechazado";
      case "REVISION":
        return "Por revisar";
      case "ACCEPTEDTERMS":
        return `${statusProgress} Aceptó terminos y condiciones`;
      case "INITIAL_DATA":
        return `${statusProgress} Datos basicos ingresados`;
      case "CAPTURING_DOC":
        return `${statusProgress} Captura de Documento`;
      case "CAPTURING_FACE":
        return `${statusProgress} Captura del rostro`;
      case "EMAIL_CONFIRMATION":
        return `${statusProgress} Confirmación de email`;
      case "PHONE_CONFIRMATION":
        return `${statusProgress} Confirmación de celular`;
      default:
        return "";
    }
  };
  const Pagination = () => {
    const { records, pageNumbers, setActivePage, setRecordsPerPage } =
      usePagination({
        activePage: currentPage + 1,
        recordsPerPage: pageSize || 10,
        totalRecordsLength: numPages * 10,
        offset: 1,
        navCustomPageSteps: { prev: 5, next: 5 },
        permanentFirstNumber: true,
        permanentLastNumber: true,
      });

    function updateActivePage(pageNumber: number | false) {
      pageNumber && dispatch(changePageState(pageNumber - 1));
      pageNumber && setActivePage(pageNumber);
    }

    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            marginLeft: "3%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <select
            style={{
              width: "50px",
              height: "30px",
              background: "#0a2a39",
              color: "white",
              border: "none",
              borderRadius: "8px",
              marginRight: "5px",
            }}
            value={pageSize || 10}
            onChange={(e) => {
              dispatch(changePageSize(parseInt(e.target.value)));
              setRecordsPerPage(parseInt(e.target.value));
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
          <p style={{ fontSize: "13px", color: "white", margin: "0 0 0 3px " }}>
            Registros por página
          </p>
        </div>
        <nav role="navigation" aria-label="Paginación">
          <ul className="pagination">
            <PaginationItem
              label={`Goto first page ${pageNumbers.firstPage}`}
              onClick={() => updateActivePage(pageNumbers.firstPage)}
            >
              <p style={{ fontSize: "25px", margin: "0px" }}>&laquo;</p>
            </PaginationItem>

            <PaginationItem
              label={`Goto previous page ${pageNumbers.previousPage}`}
              onClick={() => updateActivePage(pageNumbers.previousPage)}
            >
              <p style={{ fontSize: "25px", margin: "0px" }}>&lsaquo;</p>
            </PaginationItem>

            <PaginationItem
              label={`Goto first page ${pageNumbers.firstPage}`}
              active={pageNumbers.firstPage === pageNumbers.activePage}
              onClick={() => updateActivePage(pageNumbers.firstPage)}
            >
              {pageNumbers.firstPage}
            </PaginationItem>

            {pageNumbers.customPreviousPage && (
              <PaginationItem
                label={`Goto page ${pageNumbers.customPreviousPage}`}
                onClick={() => updateActivePage(pageNumbers.customPreviousPage)}
              >
                &middot;&middot;&middot;
              </PaginationItem>
            )}

            {pageNumbers.navigation.map((navigationNumber) => {
              const isFirstOrLastPage =
                navigationNumber === pageNumbers.firstPage ||
                navigationNumber === pageNumbers.lastPage;

              return isFirstOrLastPage ? null : (
                <PaginationItem
                  label={`Goto page ${navigationNumber}`}
                  key={navigationNumber}
                  active={navigationNumber === pageNumbers.activePage}
                  onClick={() => updateActivePage(navigationNumber)}
                >
                  {navigationNumber}
                </PaginationItem>
              );
            })}

            {pageNumbers.customNextPage && (
              <PaginationItem
                label={`Goto page ${pageNumbers.customNextPage}`}
                onClick={() => updateActivePage(pageNumbers.customNextPage)}
              >
                &middot;&middot;&middot;
              </PaginationItem>
            )}

            {pageNumbers.firstPage !== pageNumbers.lastPage && (
              <PaginationItem
                label={`Goto last page ${pageNumbers.lastPage}`}
                active={pageNumbers.lastPage === pageNumbers.activePage}
                onClick={() => updateActivePage(pageNumbers.lastPage)}
              >
                {pageNumbers.lastPage}
              </PaginationItem>
            )}

            <PaginationItem
              label={`Goto next page ${pageNumbers.nextPage}`}
              onClick={() => updateActivePage(pageNumbers.nextPage)}
            >
              <p style={{ fontSize: "25px", margin: "0px" }}>&rsaquo;</p>
            </PaginationItem>

            <PaginationItem
              label={`Goto last page ${pageNumbers.lastPage}`}
              onClick={() => updateActivePage(pageNumbers.lastPage)}
            >
              <p style={{ fontSize: "25px", margin: "0px" }}>&raquo;</p>
            </PaginationItem>
          </ul>
        </nav>
        <div style={{ height: "10px", width: "10px" }}></div>
      </div>
    );
  };

  const getTagsRender = (entityId: string) => {
    if (loadingTagsByService == "pending") {
      return <ClipLoader color="white" size="20px" />;
    } else {
      return (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3,1fr)",
            gridRowGap: "5px",
          }}
        >
          {currentServiceTags.map((tag) => {
            if (tag.associatedEntities.includes(entityId)) {
              return (
                <div
                  className="flex-row"
                  style={{
                    backgroundColor: "rgba(0,0,0,0.25)",
                    borderRadius: "8px",
                    padding: "3px 8px",
                    marginRight: "5px",
                    marginLeft: "5px",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#fff",
                      marginRight: "5px",
                    }}
                  >
                    {tag.tag}
                  </div>
                  {roles.includes("tags.edit") && (
                    <DeleteTag
                      onClick={() => {
                        dispatch(
                          disassociateTag({
                            tagId: tag.id,
                            entityId: entityId,
                            service: "COREID",
                          })
                        );
                      }}
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </div>
              );
            } else return "";
          })}
          <div>
            {roles.includes("tags.edit") && (
              <AddTag
                onClick={() => {
                  if (addTagWindow.entityId === entityId) {
                    setAddTagWindow({ entityId: "" });
                  } else {
                    setAddTagWindow({ entityId: entityId });
                  }
                }}
                style={{ cursor: "pointer", margin: "5px 0 5px 5px" }}
              />
            )}
            <div style={{ marginLeft: "-100px" }}>
              {addTagWindow.entityId === entityId && (
                <div style={{ position: "absolute", zIndex: 2 }}>
                  <div
                    style={{
                      width: "203px",
                      height: "133px",
                      background: "#1a4f64",
                      borderRadius: "8px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "start",
                      alignItems: "center",
                      padding: "8px 5px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                      }}
                    >
                      <input
                        placeholder="Agregar etiqueta"
                        style={{
                          height: "28px",
                          width: "100%",
                          background: "rgba(0, 0, 0, 0.25)",
                          borderRadius: "8px",
                          color: "white",
                          border: "none",
                          padding: "9px 8px",
                          fontSize: "11px",
                          fontWeight: 600,
                        }}
                        value={tagCreation.tag || ""}
                        onChange={(e) => {
                          dispatch(
                            setTagCreation({
                              tagId: "",
                              tag: e.target.value,
                              entityId: entityId,
                              service: "COREID",
                            })
                          );
                        }}
                      />
                      <button
                        style={{
                          height: "28px",
                          width: "28px",
                          background: "rgba(0, 0, 0, 0.25)",
                          borderRadius: "8px",
                          color: "white",
                          border: "none",
                          fontSize: "11px",
                          fontWeight: 600,
                          marginLeft: "5px",
                          visibility:
                            tagCreation.tag === "" ? "hidden" : "visible",
                        }}
                        onClick={() => {
                          if (tagCreation.tag === "") return;
                          let tagExists = allTags.find(
                            (tag) => tag.tag === tagCreation.tag
                          );
                          if (tagExists) {
                            dispatch(
                              setTagCreation({
                                tagId: tagExists.id,
                                entityId: entityId,
                                service: "COREID",
                                tag: null,
                              })
                            );
                          }
                          dispatch(createTag());
                        }}
                      >
                        <AddTag style={{ cursor: "pointer" }} />
                      </button>
                    </div>
                    <p
                      style={{
                        color: "white",
                        fontSize: "9px",
                        fontWeight: 600,
                        margin: "5px 0px",
                      }}
                    >
                      O seleccione una etiqueta existente
                    </p>
                    <div
                      placeholder="Agregar etiqueta"
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2,1fr)",
                        gridRowGap: "5px",
                        height: "70px",
                        width: "100%",
                        background: "rgba(0, 0, 0, 0.25)",
                        borderRadius: "8px",
                        color: "white",
                        border: "none",
                        padding: "9px 8px",
                        fontSize: "11px",
                        fontWeight: 600,
                        overflow: "scroll",
                      }}
                    >
                      {allTags.map((tag) => {
                        return (
                          <button
                            onClick={() => {
                              dispatch(
                                setTagCreation({
                                  tagId: tag.id,
                                  tag: tag.tag,
                                  entityId: entityId,
                                  service: "COREID",
                                })
                              );
                            }}
                            style={{
                              backgroundColor: "rgba(0,0,0,0.25)",
                              borderRadius: "8px",
                              padding: "5px 8px",
                              marginRight: "5px",
                              marginLeft: "5px",
                              justifyContent: "space-between",
                              alignItems: "center",
                              border: "none",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "9px",
                                fontWeight: 600,
                                color: "#fff",
                                marginRight: "5px",
                              }}
                            >
                              {tag.tag}
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    if (activeComponent !== "Registration") {
      dispatch(changeActiveComponent("Registration"));
    }
    dispatch(changeCurrentProduct("Core ID"));

    if (!miniDashboardData || miniDashboardData.totalRegs <= 0) {
      dispatch(getDashboardItems());
    }

    if (loadingAllTags == "idle") {
      dispatch(getAllTags());
    }

    //Set a timeout to avoid too many requests to the server
    // If a timeout is already running, reset it
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      dispatch(
        getFilteredRegistrations({
          ...currentFilteredRequest,
        })
      );
      if (currentService !== "COREID") {
        dispatch(getCurrentTagsByService("COREID"));
      }
    }, 2000);

    dispatch(resetRegistration());

    return () => {};
  }, [activeComponent, currentFilteredRequest]);
  return (
    <LoadingOverlay
      active={loading === "pending"}
      spinner={<ClipLoader color="white" size="150px" />}
    >
      {miniDashboardData &&
      registrations &&
      registrations.registrations.length > 0 ? (
        <div className="flex-col" style={{ width: "100%", height: "95%" }}>
          <div
            className="flex-row"
            style={{
              height: "13%",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <div
              className="text-xx-large text-bold primary-color"
              style={{ marginRight: "2%" }}
            >
              Registros realizados
            </div>
          </div>
          <div
            className="flex-row"
            style={{
              height: "15%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginLeft: "20px",
              marginRight: "20px",
              marginBottom: "2%",
            }}
          >
            <div
              className="text-medium text-bold primary-color"
              style={{ alignSelf: "start", marginRight: "5%" }}
            >
              Autenticaciones hoy
            </div>
            <div className="flex-row" style={{ marginRight: "5%" }}>
              <div
                className="text-medium text-bold primary-color"
                style={{ width: "min-content", marginRight: "20px" }}
              >
                Nuevos registros:
              </div>
              <div className="text-huge text-bold primary-color">
                {miniDashboardData.newRegs}
              </div>
            </div>
            <div className="flex-row" style={{ marginRight: "5%" }}>
              <div
                className="text-medium text-bold primary-color"
                style={{ width: "min-content", marginRight: "20px" }}
              >
                Registros totales
              </div>
              <div className="text-huge text-bold primary-color">
                {miniDashboardData.totalRegs}
              </div>
            </div>
            <div className="flex-row" style={{ marginRight: "5%" }}>
              <div
                className="text-medium text-bold primary-color"
                style={{ width: "min-content", marginRight: "20px" }}
              >
                Registros Completados
              </div>
              <div className="text-huge text-bold primary-color">
                {miniDashboardData.regsSuccess}
              </div>
            </div>
            <div className="flex-row" style={{ marginRight: "5%" }}>
              <div
                className="text-medium text-bold primary-color"
                style={{ width: "min-content", marginRight: "20px" }}
              >
                Registros Fallidos
              </div>
              <div className="text-huge text-bold primary-color">
                {miniDashboardData.regsFailed}
              </div>
            </div>
          </div>
          {registrations.registrations ? (
            <div className="flex-col" style={{ height: "60%" }}>
              <div style={{ overflow: "auto" }}>
                <table
                  style={{
                    width: "98%",
                    borderCollapse: "collapse",
                    marginLeft: "1%",
                  }}
                >
                  <thead
                    className="text-normal text-medium primary-color-35"
                    style={{
                      background: "rgba(0,0,0,0.4)",
                      height: "30px",
                      textAlign: "center",
                    }}
                  >
                    <tr>
                      <th></th>
                      <th>Nombre y Apellido</th>
                      <th>Fecha y Hora</th>
                      <th>E-mail</th>
                      <th>Estado</th>
                      <th>Alertas</th>
                      <th>
                        {roles.includes("tags.view")
                          ? "Etiquetas"
                          : "ID Core ID"}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody
                    className="text-normal text-x-small primary-color"
                    style={{
                      background: "rgba(0,0,0,0.2)",
                      textAlign: "center",
                    }}
                  >
                    <tr>
                      <td>&nbsp;</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    {registrations.registrations.map((reg, i) => {
                      return (
                        <tr
                          key={i}
                          className="list-hover"
                          style={{
                            height: "30px",
                          }}
                        >
                          <td></td>
                          <td
                            style={{
                              textTransform: "uppercase",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(
                                `/services/coreId/registrations/${reg.id}`
                              );
                            }}
                          >
                            {reg.fullName}
                          </td>
                          <td
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(
                                `/services/coreId/registrations/${reg.id}`
                              );
                            }}
                          >
                            {formatDateStandar(reg.dateTime)}
                          </td>
                          <td
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(
                                `/services/coreId/registrations/${reg.id}`
                              );
                            }}
                          >
                            {reg.email}
                          </td>
                          <td
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(
                                `/services/coreId/registrations/${reg.id}`
                              );
                            }}
                            style={{
                              textTransform: "uppercase",
                              cursor: "pointer",
                            }}
                          >
                            {reg.status ? getStatusName(reg) : ""}
                          </td>
                          <td
                            style={{
                              textTransform: "uppercase",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(
                                `/services/coreId/registrations/${reg.id}`
                              );
                            }}
                          >
                            {reg.alerts === 0 ? "Ninguna" : reg.alerts}
                          </td>
                          <td>
                            {roles.includes("tags.view")
                              ? getTagsRender(reg.id)
                              : reg.id}
                          </td>
                          <td></td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td>&nbsp;</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="flex-col" style={{ height: "60%" }}>
              <h1 className="text-huge text-bold primary-color">
                No hay más registros en esta página
              </h1>
            </div>
          )}
          <div
            className="flex-row"
            style={{
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              height: "5%",
              marginTop: "2%",
            }}
          >
            <Pagination />
          </div>
        </div>
      ) : (
        <div
          className="flex-col"
          style={{
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h1 className="text-huge text-bold primary-color">
            {loading === "pending" || loading === "idle"
              ? ""
              : "No hay más registros en esta página"}
          </h1>
        </div>
      )}
    </LoadingOverlay>
  );
};
